import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './BadgeAwardDescription.scss';
const BadgeAwardDescription = ({ awardableBadge, user })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { core, fragmentsGiveaway, badge } = awardableBadge;
    const { title: badgeTitle, giveExplanation } = badge;
    const username = user.username;
    if (badge.campaignEnd) {
        return /*#__PURE__*/ React.createElement("div", null, t('coreBadge.awardBadgeModal.description.specialEdition.firstLine', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            username: /*#__PURE__*/ React.createElement("span", {
                className: s['bold']
            }, username),
            badge: /*#__PURE__*/ React.createElement("span", null, badgeTitle),
            fragments: /*#__PURE__*/ React.createElement("span", null, fragmentsGiveaway)
        }), /*#__PURE__*/ React.createElement("br", null), isMobile ? /*#__PURE__*/ React.createElement("span", {
            className: s['bold']
        }, giveExplanation !== null && giveExplanation !== void 0 ? giveExplanation : t('coreBadge.awardBadgeModal.description.specialEdition.secondLine')) : giveExplanation !== null && giveExplanation !== void 0 ? giveExplanation : t('coreBadge.awardBadgeModal.description.specialEdition.secondLine'));
    }
    if (fragmentsGiveaway && core) {
        return /*#__PURE__*/ React.createElement("div", null, t('coreBadge.awardBadgeModal.description.fragmentsAndCore', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            count: fragmentsGiveaway,
            username: /*#__PURE__*/ React.createElement("span", {
                className: s['bold']
            }, username),
            badge: /*#__PURE__*/ React.createElement("span", null, badgeTitle),
            fragments: /*#__PURE__*/ React.createElement("span", null, fragmentsGiveaway),
            br: /*#__PURE__*/ React.createElement("br", null),
            coreSymbol: /*#__PURE__*/ React.createElement(CoreSymbol, {
                className: s['core-star'],
                corePackage: 'generic',
                size: IconSize.SMALL
            }),
            core: t('coreBadge.awardBadgeModal.description.fragmentsAndCore.coreGiveaway.v2', {
                postProcess: [
                    'reactPostprocessor',
                    'featureBrancher'
                ],
                core: /*#__PURE__*/ React.createElement("span", {
                    className: s['core-label']
                }, "Core")
            }),
            endMessage: isMobile ? /*#__PURE__*/ React.createElement("span", {
                className: s['bold']
            }, giveExplanation) : giveExplanation
        }));
    }
    if (fragmentsGiveaway) {
        return /*#__PURE__*/ React.createElement("div", null, t('coreBadge.awardBadgeModal.description.fragments', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            count: fragmentsGiveaway,
            username: /*#__PURE__*/ React.createElement("span", {
                className: s['bold']
            }, username),
            badge: /*#__PURE__*/ React.createElement("span", null, badgeTitle),
            fragments: /*#__PURE__*/ React.createElement("span", null, fragmentsGiveaway),
            br: /*#__PURE__*/ React.createElement("br", null),
            endMessage: isMobile ? /*#__PURE__*/ React.createElement("span", {
                className: s['bold']
            }, giveExplanation) : giveExplanation
        }));
    }
    // We don't have a case where user only gets a core without fragments
    return null;
};
BadgeAwardDescription.displayName = 'BadgeAwardDescription';
export default BadgeAwardDescription;

//# sourceMappingURL=BadgeAwardDescription.js.map